import useBulkWalletEventData from '../../hooks/useBulkWalletEventData'

interface Props {
  eventIds: number[] | string[]
  skipLocation?: boolean
}

const EventDataFetcher: React.FC<Props> = (props: Props) => {
  const { eventIds, skipLocation } = props

  useBulkWalletEventData({ eventIds, skipLocation })

  return null
}

export default EventDataFetcher
